// @flow

import { observer } from "mobx-react";
import * as React from "react";
import ResizeObserver from "react-resize-observer";

import TimelineItem from "app/models/TimelineItem";
import Video from "app/models/Video";

import "./TimelineCardPositioner.scss";

type Props = {
    video: Video,
    selectedItem: TimelineItem,
    isExpanded: boolean,
    children: React.Node
};

type State = {
    containerWidth: number,
    latestItem: ?TimelineItem
};

@observer
export default class TimelinePositioner extends React.Component<Props, State> {
    constructor() {
        super();
        this.state = {
            containerWidth: 880,
            latestItem: null
        };
    }

    componentDidUpdate = () => {
        if (
            this.props.selectedItem &&
            this.props.selectedItem !== this.state.latestItem
        ) {
            this.setState({ latestItem: this.props.selectedItem });
        }
    };

    render() {
        const video = this.props.video;
        const item = this.props.selectedItem;
        let classes = ["TimelineCardPositioner"];
        let indicatorArrowPosition =
            ((item.start_time + item.duration / 2) / video.duration) *
            this.state.containerWidth;

        return (
            <div className={classes.join(" ")}>
                <ResizeObserver
                    onResize={rect => {
                        this.setState({ containerWidth: rect.width });
                    }}
                />
                <i
                    className="fa fa-caret-up"
                    aria-hidden="true"
                    style={{ left: indicatorArrowPosition }}
                ></i>
                <div className="TimelineCardPositioner__content">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardPositioner/TimelineCardPositioner.js